import type { OnDestroy } from '@angular/core';
import { Injectable, NgZone } from '@angular/core';
import { Keyboard } from '@capacitor/keyboard';
import { Pwa } from '@freelancer/pwa';
import type { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class KeyboardService implements OnDestroy {
  private _isOpenSubject$ = new Subject<boolean>();
  private listenersAdded = false;

  constructor(
    private pwa: Pwa,
    private ngZone: NgZone,
  ) {}

  isOpen(): Observable<boolean> {
    if (!this.listenersAdded && this.pwa.isNative()) {
      this.addListeners();
    }

    return this._isOpenSubject$.asObservable().pipe(startWith(false));
  }

  async addListeners(): Promise<void> {
    Keyboard.addListener('keyboardWillShow', () => {
      this.ngZone.run(() => {
        this._isOpenSubject$.next(true);
      });
    });

    Keyboard.addListener('keyboardDidHide', () => {
      this.ngZone.run(() => {
        this._isOpenSubject$.next(false);
      });
    });

    this.listenersAdded = true;
  }

  async removeListeners(): Promise<void> {
    Keyboard.removeAllListeners();
  }

  ngOnDestroy(): void {
    if (this.listenersAdded && this.pwa.isNative()) {
      this.removeListeners();
    }
  }
}
